import React, { useState } from 'react';
import {
    ListingContainer,
    ListingHeader,
    Table,
    TableRow,
    TableHeaderCell,
    TableCell,
    TypeCell,
    DownloadIcon,
    Pagination,
    PaginationButton,
    LeftArrow,
    RightArrow,
} from './ListingCard.styles';

const Listing = ({ title, headers, columns, data, rowsPerPage = 3, columnStyle }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const currentData = data.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    const totalPages = Math.ceil(data.length / rowsPerPage);

    return (
        <ListingContainer>
            <ListingHeader>{title}</ListingHeader>
            <Table>
                <thead>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableHeaderCell key={index}>{header}</TableHeaderCell>
                        ))}
                    </TableRow>
                </thead>
                <tbody>
                    {currentData.map((item, index) => (
                        <TableRow key={index}>
                            {columns.map((col, colIndex) => (
                                <TableCell key={colIndex} style={columnStyle}>
                                    {col === "type" ? (
                                        <TypeCell type={item[col]}>{item[col]}</TypeCell>
                                    ) : col === "link" ? (
                                        <DownloadIcon
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                link.href = item[col];
                                                link.download = item.title;
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}
                                        />
                                    ) : (
                                        item[col]
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </tbody>
            </Table>
            <Pagination>
                <LeftArrow
                    onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                />
                {[...Array(totalPages).keys()].map((page) => (
                    <PaginationButton
                        key={page}
                        active={currentPage === page + 1}
                        onClick={() => setCurrentPage(page + 1)}
                    >
                        {page + 1}
                    </PaginationButton>
                ))}
                <RightArrow
                    onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                />
            </Pagination>
        </ListingContainer>
    );
};

export default Listing;